import React, { useEffect } from 'react';
import {connect} from 'react-redux';
import { useNavigate } from 'react-router-dom';
import firebase from '../../config/firebase';
import { change_lang,remove_parent_user } from '../../store/action';
import { withTranslation } from 'react-i18next';
import Skeleton from '@mui/material/Skeleton';
import makeStyles from '@mui/styles/makeStyles';
import { ClickAwayListener, Grow, Paper, Popper, MenuItem, MenuList,Button } from '@mui/material';
import MenuOutlined from '@mui/icons-material/MenuOutlined';
import Logo from 'src/assets/images/institution.png';
import GetImageDimensions from 'src/screens/WhiteLabels/Templates/shared/logic/getImgDimensions';

const useStyles = makeStyles(theme => ({
    header:{
        height:'55px',
        minHeight:'55px',
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'space-between',
        backgroundColor:'#FFF',
        borderRadius:'6px',
        marginTop:'50px',
        width:'calc(100% - 50px)',
        margin:'0px auto',
        borderRadius:'7px',
        boxShadow: '0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)',
        [theme.breakpoints.between('xs','md')]:{
            marginTop:'25px',
            width:'calc(100% - 15px)',
        }
    },

    leftSection:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center'
    },

    childDiv:{
        display:'flex',
        flexDirection:'column',
        justifyContent:'center',
        padding:'0px 10px',
        borderRadius: '4px',
        cursor:'pointer',
        height:'48px',
        transition:'0.5s',
        "&:hover":{
            backgroundColor: '#fff'
        }
    },

    refDiv:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        backgroundColor: '#0F467A',
        borderRadius: '10px',
        minHeight: '40px',
        minWidth:'40px',
        fontSize:'.75rem',
        width:'max-content',
        padding: '0px 20px',
        boxShadow: '0px 3px 6px #00000029',
        [theme.breakpoints.between('xs','md')]:{
            padding:'0px 10px'
        }
    },

    text:{
        fontSize:'17px',
        textTransform:'uppercase',
        color: '#fff',
        textAlign: 'center',
        fontWeight: 'bold',
        [theme.breakpoints.between('xs','md')]:{
            fontSize:'9px',
        }
    },

    marLeft:{
        marginLeft:'10px'
    },

    marRight:{
        marginRight:'10px'
    },

    logoDiv:{
        // maxWidth:'200px',
        // maxHeight:'100px',
        // overflow:'hidden',
        margin:'0px 40px',
        cursor:'pointer',
        // height: props => props.height > 600 ? '90px' : '200px',

        '& img':{
            // width:'100%',
            height:'100%',
            maxHeight:'35px',
            verticalAlign:'middle',
        },

        [theme.breakpoints.between('xs','md')]:{
            // maxWidth:'130px',
            // height: props => props.height > 600 ? '70px' : 'unset',
            margin:'0px 10px',
        }
    },

    rowDiv:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center'
    }
}));

function CustomMenu(props) {
    return (
        <Popper open={props.open} anchorEl={props.childRef} role={undefined} transition disablePortal>
        {({ TransitionProps, placement }) => (
            <Grow
            {...TransitionProps}
            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
            >
            <Paper>
                <ClickAwayListener onClickAway={props.handleClose}>
                    {props.childComponent}
                </ClickAwayListener>
            </Paper>
            </Grow>
        )}
        </Popper>
    )
}

function BookingHeader(props) {
    const { t, lang, i18n, change_lang, company,customClass, companyImage, langBtn, logoCustomCls, logoClickEvent, company_id } = props;
    const [languageOpen, setLangOpen] = React.useState(false);
    const [listOpen, setListOpen] = React.useState(false);
    const [currencyOpen, setCurOpen] = React.useState(false);
    const [language,setLang] = React.useState(lang)
    const languageRef = React.useRef(null);
    const listRef = React.useRef(null);
    const [imageDimensions, setImageDimensions] = React.useState({});
    const navigate = useNavigate();
    const isRTL = i18n.translator.language;
    const ar = "'Cairo', sans-serif";
    const en = "'Poppins', sans-serif";
    const fontFamily = isRTL === 'ar' ? ar : en;
    const classes = useStyles(imageDimensions);
    const avatar = companyImage ? companyImage : company && company?.avatar ? company?.avatar : '';

    React.useEffect(() => {
        GetImageDimensions(setImageDimensions, avatar);
    }, [avatar]);

    // useEffect(() => {
    //     let mounted = true
    //     if(window.navigator && window.navigator.language) {
    //         let browserLanguage = window.navigator.language;
    //         change_lang(browserLanguage === 'ar' ? browserLanguage : 'en');
    //         i18n.changeLanguage(browserLanguage === 'ar' ? browserLanguage : 'en');
    //         if (mounted) setLang(browserLanguage === 'ar' ? browserLanguage : 'en');
    //     }
    //     return function cleanup() {
    //         mounted = false
    //     }
    // }, [])

    const handleToggle = (id) => {
        if(id === 'languageOpen') setLangOpen(!languageOpen);
        if(id === 'listOpen') setListOpen(!listOpen);
        if(id === 'currencyOpen') setCurOpen(!currencyOpen);
    };

    const handleClose = (id) => {
        if(id === 'currencyOpen') setCurOpen(false);
        if(id === 'listOpen') setListOpen(false);
        if(id === 'languageOpen') setLangOpen(false);
    }

    const handleListKeyDown = (event) => {
        if (event.key === 'Tab') {
            event.preventDefault();
            setLangOpen(!languageOpen);
            setListOpen(!listOpen);
            setCurOpen(!currencyOpen);
        }
    }

    const update_lang = e => {
        let { change_lang, i18n } = props;
        change_lang(e);
        i18n.changeLanguage(e);
        setLangOpen(!languageOpen);
        setLang(e);
    }

    const logout = () => {
        let { logout_user, company } = props;
        const { urlName, domain, id } = company || {};
        const host = window.location.host;

        firebase.auth().signOut().then(() => {
            logout_user();
            if(domain === host) {
                navigate(`/`);
            }
            else if(urlName){
                navigate(`/${urlName}`);
            }
            else{
                navigate(`/${id}`);
            };
        })
    };

    const redirectWebsite = () => {
        const { urlName, domain } = company || {};
        const host = window.location.host;
        if(company_id) navigate(domain === host ? '/': urlName ? `/${urlName}` : `/company/${company_id}`);
    };

    const homeRedirect = () => {
        const { company } = props;
        const { urlName, domain, id } = company || {};
        const host = window.location.host;

        if(domain === host) {
            navigate(`/`);
        }
        else if(urlName){
            navigate(`/${urlName}`);
        }
        else{
            navigate(`/${id}`);
        };
        setListOpen(!listOpen)
    }
    
    return (
        (<div className={`${classes.header} ${customClass || ''}`}>
            <div className={classes.leftSection}>
                {avatar?
                <div className={`${classes.logoDiv} ${logoCustomCls}`} onClick={logoClickEvent ? logoClickEvent : redirectWebsite}>
                    <img alt="logo" src={avatar || Logo} />
                </div>
                : 
                <Skeleton variant="rectangular" width={200} height={35} style={{margin:'0px 40px'}} />
                }
            </div>
            {langBtn ?
            langBtn
            :
            <div className={classes.rowDiv}>
                <div className={`${classes.childDiv} ${isRTL === 'ar' ? classes.marRight : classes.marLeft}`}>
                    <div className={classes.refDiv}
                        ref={languageRef}
                        aria-controls={languageOpen ? 'menu-list-grow' : undefined}
                        aria-haspopup="true"
                        onClick={() => handleToggle('languageOpen')}
                        >
                        <span className={classes.text} style={{fontSize:'0.75rem'}}>{language === 'en' ? t('setting-comp.en') : t('setting-comp.ar')}</span>
                    </div>
                    <CustomMenu
                        open={languageOpen}
                        childRef={languageRef.current}
                        handleClose={()=> handleClose('languageOpen')}
                        childComponent={
                            <MenuList autoFocusItem={languageOpen} id="menu-list-grow" onKeyDown={() => handleListKeyDown('languageOpen')}>
                                <MenuItem style={language === 'en' ? {fontFamily:'inherit',backgroundColor:'#0F467A',color:'#fff'} : {fontFamily:'inherit',backgroundColor:'transparent'}} onClick={()=> update_lang('en')} value="en">{t('setting-comp.en')}</MenuItem>
                                <MenuItem style={language === 'ar' ? {fontFamily:'inherit',backgroundColor:'#0F467A',color:'#fff'} : {fontFamily:'inherit',backgroundColor:'transparent'}} onClick={()=> update_lang('ar')} value="ar">{t('setting-comp.ar')}</MenuItem>
                            </MenuList>
                        }                        
                    />
                </div>
                {props.user && props.user.id ?
                    <>
                        <Button
                            ref={listRef}
                            aria-controls={listOpen ? 'menu-list-grow' : undefined}
                            aria-haspopup="true"
                            onClick={() => handleToggle('listOpen')}
                            style={{margin:'0px 10px'}}
                            color="inherit"
                            >
                            <MenuOutlined style={{fontSize:'1.9rem'}}/>
                        </Button>
                        <Popper open={listOpen} anchorEl={listRef.current} role={undefined} transition disablePortal>
                        {({ TransitionProps, placement }) => (
                            <Grow
                            {...TransitionProps}
                            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                            >
                            <Paper>
                                <ClickAwayListener onClickAway={()=> handleClose('listOpen')}>
                                <MenuList autoFocusItem={listOpen} id="menu-list-grow" onKeyDown={() => handleListKeyDown('listOpen')}>
                                    <MenuItem onClick={homeRedirect}>{t('companyPage.home')}</MenuItem>
                                    <MenuItem onClick={logout}>{t('component.sidebar.signout')}</MenuItem>
                                </MenuList>
                                </ClickAwayListener>
                            </Paper>
                            </Grow>
                        )}
                        </Popper>
                    </>
                : null}
            </div>
            }
        </div>)
    );
}

const mapDispatchToProps = dispatch => {
    return {
        change_lang : lang => dispatch(change_lang(lang)),
        logout_user : () => dispatch(remove_parent_user()),
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        lang: state.lang,
        company: state.company,
        company_id: state.company_id,
    };
};

export default connect(mapStateToProps,mapDispatchToProps)(withTranslation('common')(BookingHeader));